import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import Input from '../../../../components/Form/Input'
import ButtonBlack from '../../../../components/Buttons/ButtonBlack'
import axios from 'axios';
import { API_END_POINT } from '../../../../utils/constant'
import  {districtDatas as district, regionDatas as region} from "../../../../plateform/datas/RegionDistrict"
import Select from '../../../../components/Form/Select';

const CreateCandidateAccount = ({ setPage, page, data, setData }) => {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [touchedFields, setTouchedFields] = useState({});

  // Fonction de validation du formulaire
  const validateForm = () => {
    let newErrors = {};

    if (!data.nom) newErrors.nom = "Le nom est requis.";
    if (!data.prenom) newErrors.prenom = "Le prénom est requis.";
    if (!data.phone) newErrors.phone = "Le numéro de téléphone est requis.";
    if (!data.region) newErrors.region = "Veuillez choisir une région.";
    if (!data.district) newErrors.district = "Veuillez choisir un district.";

    if (!data.email) {
      newErrors.email = "L'email est requis.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
      newErrors.email = "Veuillez entrer une adresse email valide.";
    }

    if (!data.password) {
      newErrors.password = "Le mot de passe est requis.";
    } else if (data.password.length < 8) {
      newErrors.password = "Le mot de passe doit avoir au moins 8 caractères.";
    }

    if (!data.confirmPassword) {
      newErrors.confirmPassword = "Veuillez confirmer votre mot de passe.";
    } else if (data.password !== data.confirmPassword) {
      newErrors.confirmPassword = "Les mots de passe ne correspondent pas.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleChange = async (e) => {
    const { name, value, type, checked } = e.target;
    setData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  
    if (name === "email") {
      // Vérifier localement si l'email est valide avant d'appeler l'API
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
      if (!emailRegex.test(value)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          email: "L'email n'est pas valide.",
        }));
        return;
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          email: null,
        }));
  
        // Vérification de l'unicité de l'email via l'API
        try {
          const response = await axios.post(`${API_END_POINT}/verifyEmail`, {
            email: value,
          });
  
          console.log("Vérification déclenchée", value, response.data.isUnique);
  
          if (!response.data.isUnique) {
            setErrors((prevErrors) => ({
              ...prevErrors,
              email: "Cet email est déjà utilisé.",
            }));
          }
        } catch (error) {
          console.error("Erreur lors de la vérification de l'email :", error);
        }
      }
    }
  
    // Vérification des mots de passe
    if (name === "password" || name === "confirmPassword") {
      setErrors((prevErrors) => ({
        ...prevErrors,
        confirmPassword:
          name === "confirmPassword" && value !== data.password
            ? "Les mots de passe ne correspondent pas."
            : null,
      }));
    }
  };
  
  // const handleChange = async (e) => {
  //   const { name, value, type, checked } = e.target;
  //   setData({
  //     ...data,
  //     [name]: type === 'checkbox' ? checked : value,
  //   });
  
  //   // Vérification de l'email
  //   if (name === "email") {
  //     const emailRegex =  /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  //     if (!emailRegex.test(value)) {
  //       setErrors({
  //         ...errors,
  //         email: "L'email n'est pas valide.",
  //       });
  //       return;
  //     } else {
  //       setErrors({
  //         ...errors,
  //         email: null,
  //       });
  
  //       // Vérifier l'unicité de l'email via l'API
  //       try {
          
  //         const response = await axios.post(`${API_END_POINT}/verifyEmail`, {email: value});
  //         console.log("verfication déclenché", value, response.data.isUnique)
  //         if (!response.data.isUnique) {
  //           setErrors({
  //             ...errors,
  //             email: "Cet email est déjà utilisé.",
  //           });
  //         }
  //       } catch (error) {
  //         console.error("Erreur lors de la vérification de l'email :", error);
  //       }
  //     }
  //   }
  
  //   // Vérification des mots de passe
  //   if (name === 'password' || name === 'confirmPassword') {
  //     if (name === "password" && data.confirmPassword && value !== data.confirmPassword) {
  //       setErrors({
  //         ...errors,
  //         confirmPassword: "Les mots de passe ne correspondent pas.",
  //       });
  //     } else if (name === "confirmPassword" && data.password && value !== data.password) {
  //       setErrors({
  //         ...errors,
  //         confirmPassword: "Les mots de passe ne correspondent pas.",
  //       });
  //     } else {
  //       setErrors({
  //         ...errors,
  //         confirmPassword: null,
  //       });
  //     }
  //   } else {
  //     setErrors({
  //       ...errors,
  //       [name]: null,
  //     });
  //   }
  // };
  

  // Gestion des changements dans les inputs
  // const handleChange = (e) => {
  //   const { name, value, type, checked } = e.target;
  //   setData({
  //     ...data,
  //     [name]: type === 'checkbox' ? checked : value,
  //   });

  //       if (name === 'password' || name === 'confirmPassword') {
  //     if (data.password !== data.confirmPassword) {
  //       setErrors({
  //         ...errors,
  //         confirmPassword: "Les mots de passe ne correspondent pas.",
  //       });
  //       // setPasswordError("Les mots de passe ne correspondent pas.");
  //     }else{
  //       setErrors({
  //         ...errors,
  //         confirmPassword: "",
  //       });
  //     }
  //   }else {
  //     setErrors({
  //       ...errors,
  //       [name]: null,
  //     });
  //   }

  //   // Suppression de l'erreur si l'utilisateur corrige son entrée
  
  // };

  // Gestion du focus
  const handleFocus = (e) => {
    const { name } = e.target;
    setTouchedFields({
      ...touchedFields,
      [name]: true,
    });
  };

  // Gestion du blur
  const handleBlur = (e) => {
    const { name, value } = e.target;
    if (touchedFields[name] && value.trim() === "") {
      setErrors({
        ...errors,
        [name]: "Ce champ est requis.",
      });
    }
  };

  // Fonction d'enregistrement
  const save = async () => {
    if (!validateForm()) return;

    try {
      setLoading(true);
      const updatedData = {
        ...data,
        codeGenerated: Math.ceil(Math.random() * 9001) + 999,
      };

      setData(updatedData);
      // await axios.post(API_END_POINT + "/sendCode", updatedData);

      setPage(page + 1);
    } catch (error) {
      console.error("Erreur lors de l'inscription:", error);
      setErrors({ api: "Une erreur est survenue. Veuillez réessayer plus tard." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full p-4 md:p-6 space-y-8 sm:p-8 bg-white rounded-lg shadow my-6">
      <h2 className="text-2xl font-bold text-gray-900 text-center">Créer un compte</h2>
      {errors.api && <p className="text-red-500 text-sm">{errors.api}</p>}
      <form className="mt-8 space-y-2">
      <div className="grid-2">
        <Input label="Nom" name="nom" value={data.nom} 
          onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} error={errors.nom} />
        <Input label="Prénom" name="prenom" value={data.prenom} 
          onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} error={errors.prenom} />
      </div>
      <Input label="Téléphone" name="phone" value={data.phone} 
          onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} error={errors.phone} />
      <div className=' flex flex-col justify-start'>
      <div className='text-start' htmlFor="">Sexe</div>
      <div className="flex flex-col sm:inline-flex sm:flex-row rounded-lg shadow-2xs">
        <button type="button" className="py-2.5 px-4 inline-flex items-center gap-x-2 -mt-px -ms-px first:rounded-t-md last:rounded-b-md sm:first:rounded-s-md sm:mt-0 sm:first:ms-0 sm:first:rounded-se-none sm:last:rounded-es-none sm:last:rounded-e-md text-sm font-medium focus:z-10 border border-gray-200 bg-white text-gray-800 shadow-2xs hover:bg-gray-50 focus:outline-hidden focus:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none  ">
        Homme
        </button>
        <button type="button" className="py-2.5 px-4 inline-flex items-center gap-x-2 -mt-px -ms-px first:rounded-t-md last:rounded-b-md sm:first:rounded-s-md sm:mt-0 sm:first:ms-0 sm:first:rounded-se-none sm:last:rounded-es-none sm:last:rounded-e-md text-sm font-medium focus:z-10 border border-gray-200 bg-white text-gray-800 shadow-2xs hover:bg-gray-50 focus:outline-hidden focus:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none  ">
          Femme
        </button>
      </div>
        </div>

      <div className="grid-2">
        <Select label="Région" name="region" value={data.region} 
          onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} options={region} error={errors.region} />
        <Select label="District" name="district" value={data.district} 
          onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} options={data.region ? district[data.region] : []} error={errors.district} />
      </div>

      <Input label="Email" name="email" value={data.email} type="email" 
        onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} error={errors.email} />

      <Input label="Mot de passe" name="password" value={data.password} type="password" 
        onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} error={errors.password} />

      <Input label="Confirmer le mot de passe" name="confirmPassword" value={data.confirmPassword} type="password" 
        onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} error={errors.confirmPassword} />
</form>
      <ButtonBlack 
        onClick={save} 
        radius='sm'
        className="w-full  text-white py-2 px-4 rounded-sm "
        isLoading={loading}
      >
        {loading ? "Enregistrement..." : "Créer un compte"}
      </ButtonBlack>
    </div>
  );
};


// const CreateCandidateAccount = ({ setPage, page, data, setData, user }) => {
//   const [code, setCode] = useState(Math.ceil(Math.random() * 9001) + 999);
//   const [loading, setLoading] = useState(false);
//   const [passwordError, setPasswordError] = useState("");
//   const [touchedFields, setTouchedFields] = useState({});
//   const [errors, setErrors] = useState({});

//   // Handle changes in form inputs
//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setData({
//       ...data,
//       [name]: type === 'checkbox' ? checked : value,
//     });

//     // Update password validation if password or confirmPassword changes
//     if (name === 'password' || name === 'confirmPassword') {
//       if (data.password !== data.confirmPassword) {
//         setPasswordError("Les mots de passe ne correspondent pas.");
//       } else {
//         setPasswordError("");
//       }
//     }
//   }

//   const validateForm = () => {
//     let newErrors = {};

//     if (!data.email.trim()) newErrors.job_title = "L'email est requis.";
   
//     setErrors(newErrors);

//     return Object.keys(newErrors).length === 0;
//   };

//   // Form submission
//   const save = async () => {
//     // Ensure password validation
//     if (data.password !== data.confirmPassword) {
//       setPasswordError("Les mots de passe ne correspondent pas.");
//       return;
//     }

//     if(validateForm()){
//       try {
      
//         const updatedData = {
//           ...data, 
//           codeGenerated: Math.ceil(Math.random() * 9001) + 999,
//         }
        
//         setData(updatedData);
      
//         console.log('Code généré:',  updatedData);
  
//         // await axios.post(API_END_POINT + '/sendCode', updatedData)
//         // .then((response)=>{
//         //   if(response.data.isSent)
//             setPage(page + 1);
//         // })
//         // .catch((error)=>{
//         //   setLoading(false);
//         // })
  
//         // setLoading(false);
//         // // Move to next page or handle success
//         // setPage(page + 1);
//       } catch (error) {
//         console.error('Error during registration:', error);
//         // setLoading(false);
//       }
//     }


//     setLoading(false);
//   };

//     // Gestion du focus
//     const handleFocus = (e) => {
//       const { name } = e.target;
//       setTouchedFields({
//         ...touchedFields,
//         [name]: true,
//       });
//     };
  
//     // Gestion du blur
//     const handleBlur = (e) => {
//       const { name, value } = e.target;
  
//       if (touchedFields[name] && value.trim() === "") {
//         setErrors({
//           ...errors,
//           [name]: "Ce champ est requis.",
//         });
//       }
//     };

//   return (
//     <div className="w-full p-4 md:p-6 space-y-8 sm:p-8 bg-white rounded-lg shadow mt-20">
//       <h2 className="text-2xl font-bold text-gray-900 dark:text-white">Créer un compte</h2>
//       <div className="grid-2">
//         <Input label="Nom" name="nom" value={data.nom} onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} error={errors.firstname}/>
//         <Input label="Prénom" name="prenom" value={data.prenom} onChange={handleChange} />
//       </div>

//       <div className="grid-2">
//         <div className="relative mb-2">
//           <label htmlFor="region" className="block text-sm font-medium text-gray-700 text-start">Région</label>
//           <select
//             id="region"
//             name="region"
//             value={data.region}
//             onChange={handleChange}
//             className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
//             required
//           >
//             <option value="">Choisissez une région</option>
//             {region.map((item, index) => (
//               <option key={index} value={item}>{item}</option>
//             ))}
//           </select>
//         </div>

//         <div className="relative mb-2">
//           <label htmlFor="district" className="block text-sm font-medium text-gray-700 text-start">District</label>
//           <select
//             id="district"
//             name="district"
//             value={data.district}
//             onChange={handleChange}
//             className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
//             required
//           >
//             <option value="">Choisissez un district</option>
//             {data.region && district[data.region].map((item, index) => (
//               <option key={index} value={item}>{item}</option>
//             ))}
//           </select>
//         </div>
//       </div>

    
//       <Input label="Téléphone" type="text" name="phone" value={data?.email} onChange={handleChange} required />
//       <Input label="Sexe" type="text" name="gender" value={data?.email} onChange={handleChange} required />

//       <Input label="Email" type="email" name="email" value={data?.email} onChange={handleChange} required />
//       <div className="grid-2">
//         <Input
//           label="Mot de passe"
//           type="password"
//           name="password"
//           value={data.password}
//           onChange={handleChange}
//           required
//         />
//         <Input
//           label="Confirmation mot de passe"
//           type="password"
//           name="confirmPassword"
//           value={data.confirmPassword}
//           onChange={handleChange}
//           required
//           className={passwordError ? 'border-red-500' : ''}
//           error={passwordError}
//         />
//       </div>

//       {/* {passwordError && (
//         <p className="text-red-500 text-sm">Les mots de passe ne correspondent pas.</p>
//       )} */}

//       <p className="text-start font-medium text-gray-900 text-sm">
//         Veuillez utiliser un mot de passe avec un minimum de 8 caractères.
//       </p>

//       <div className="flex items-start py-2">
//         <div className="flex items-center h-5">
//           <input
//             id="remember"
//             name="remember"
//             type="checkbox"
//             checked={data.remember}
//             onChange={handleChange}
//             className="w-4 h-4 border-gray-300 rounded bg-gray-50"
//           />
//         </div>
//         <div className="ml-3 text-sm">
//           <label htmlFor="remember" className="font-medium text-gray-900">
//             J'accepte les{' '}
//             <Link to="/termes-et-conditions" className="text-primary-700 hover:underline font-semibold">
//               Termes et Conditions
//             </Link>
//           </label>
//         </div>
//       </div>

//       <ButtonBlack disabled={loading} onClick={save} DefaultClassName="w-80 mx-auto py-3 rounded-md">
//         Suivant
//       </ButtonBlack>

//       <div className="text-sm font-medium text-gray-500">
//         Déjà un compte ?{' '}
//         <Link to="/login" className="text-gray-800 hover:underline">
//           Se connecter
//         </Link>
//       </div>
//     </div>
//   );
// };

export default CreateCandidateAccount;
